import axios from 'axios';

const contentApiBaseUrl = (process.env.REACT_APP_CMS_CONTENT_IP || '').trim();
const playlistApiBaseUrl = (process.env.REACT_APP_CMS_PLAYLIST_IP || '').trim();

function needsAuthHeader(url, method) {
    const isContentApi = contentApiBaseUrl && url.startsWith(contentApiBaseUrl);
    const isPlaylistApi = playlistApiBaseUrl && url.startsWith(playlistApiBaseUrl);

    // Content aggregator: POST / PUT / DELETE only
    if (isContentApi && ['post', 'put', 'delete'].includes(method)) {
        return true;
    }

    // Playlist API: GET / POST / PUT / DELETE (protected endpoints require token)
    if (isPlaylistApi && ['get', 'post', 'put', 'delete'].includes(method)) {
        return true;
    }

    return false;
}

axios.interceptors.request.use((config) => {
    const method = (config.method || '').toLowerCase();
    const url = (config.url || '').trim();

    if (needsAuthHeader(url, method)) {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    }
    return config;
}, (error) => Promise.reject(error));

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isLoginPage = window.location.pathname === '/login';
            localStorage.removeItem('authToken');
            localStorage.removeItem('storeId');
            localStorage.removeItem('role');
            localStorage.removeItem('userRole');
            localStorage.removeItem('userId');
            if (!isLoginPage) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
